import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Elevations } from 'mojo-card';

import { CandidateAdapter, Job } from '@shared';

import { ComponentsConfig, ComponentsPrivileges, } from '../components.abstract.config';

@Component({
  selector: 'mojo-job',
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobComponent {
  @Input() candidate: CandidateAdapter;
  @Input() job: Job;
  @Input() index: number;

  privileges: ComponentsPrivileges;
  elevation = Elevations.second;

  constructor(private componentsConfig: ComponentsConfig) {
    this.privileges = this.componentsConfig.privileges;
  }
}
